import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';

// service
import { AuthenticationService } from 'src/app/core/service/auth.service';
import { EventService } from 'src/app/core/service/event.service';
import { ArbitrosService } from 'src/app/arbitros/arbitros.service';
import { getCurrentLanguage } from 'src/app/core/helpers/utils';

// constant
import { EventType, AvatarPayload } from 'src/app/core/constants/events';

// types
import { User } from 'src/app/core/models/auth.models';
import { NotificationItem } from '../models/notification.model';
import { ProfileOptionItem } from '../models/profileoption.model';
import { SearchResultItem, SearchUserItem } from '../models/search.model';

// data
import { NOTIFICATIONS, PROFILEOPTIONS } from './data';
import { PageTitle } from '../models/page-title.model';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

  notificationList: NotificationItem[] = [];
  profileOptions: ProfileOptionItem[] = [];
  searchResults: SearchResultItem[] = [];
  searchUsers: SearchUserItem[] = [];
  pageTitle: string = '';
  loggedInUser?: string = '';
  nombreCompleto?: string = '';
  isAdmin: boolean = false;
  topnavCollapsed: boolean = false;
  loaded: boolean = false;
  avatarUrl?: SafeUrl;

  urlProfile?: string = '';

  @Input() layoutType: string = 'vertical';
  @Input() containerClass?: string = '';

  // output events
  @Output() mobileMenuButtonClicked = new EventEmitter<void>();

  constructor(
    private authService: AuthenticationService,
    private eventService: EventService,
    private arbitrosService: ArbitrosService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    this.eventService.on(EventType.CHANGE_PAGE_TITLE).subscribe(({ payload }) => {
      this.pageTitle = (payload as PageTitle).title;
    });
  }

  ngOnInit(): void {
    this._fetchSearchData();
    this._fetchNotifications();
    this._fetchProfileOptions();

    this.authService.currentUser().subscribe(user => {
      // En este punto, user tiene toda la información actualizada, incluido nivel_acceso
      this.loggedInUser = user?.firstName
      this.nombreCompleto = user?.firstName + " " + user?.lastName
      this.isAdmin = user?.nivel_acceso === 'ADMIN';


      /*
      // Escuchar el nuevo evento UPDATE_NAME para recargar el avatar cuando se actualice
      this.eventService.on(EventType.UPDATE_NAME).subscribe((event) => {
        this.nombreCompleto = user?.firstName + " " + user?.lastName // Vuelve a cargar el nombre
      });
      */



      const currentLanguage = getCurrentLanguage();

      if (user?.es_arbitro)
        this.urlProfile = "arbitros/edit/" + user?.id;
      else
        this.urlProfile = "usuarios/edit/" + user?.id;


      // Consigo el avatar
      if (user?.id) {
        this.loadAvatar(user?.id);

        // Escuchar el nuevo evento UPDATE_AVATAR para recargar el avatar cuando se actualice
        this.eventService.on(EventType.UPDATE_AVATAR).subscribe((event) => {
          const payload = event.payload as AvatarPayload;
          if (payload.userId === user.id) {
            this.loadAvatar(user.id); // Vuelve a cargar el avatar
          }
        });
      }
    });
  }

  loadAvatar(id: string) {
    // Código que ya tienes para obtener el avatar del usuario
    if (id) {
      this.arbitrosService.getAvatar(id).subscribe((avatarBlob) => {
        if (avatarBlob) {
          const blobUrl = URL.createObjectURL(avatarBlob);
          this.avatarUrl = this.sanitizer.bypassSecurityTrustUrl(blobUrl);
          this.loaded = true;
        }
      });
    }
  }

  /**
   * Fetches notifications
   */
  _fetchNotifications(): void {
    this.notificationList = NOTIFICATIONS;
  }

  /**
   * Fetches profile options
   */
  _fetchProfileOptions(): void {
    this.profileOptions = PROFILEOPTIONS;
  }


  /**
   * Fetches search results
   */
  _fetchSearchData(): void {
    this.searchResults = [{
      /*
      id: 1,
      text: 'Analytics Report',
      icon: 'fe-home',
    },
    {
      id: 2,
      text: 'How can I help you?',
      icon: 'fe-aperture',
    },
    {
      id: 3,
      text: 'User profile settings',
      icon: 'fe-settings',
    }];

    this.searchUsers = [{
      id: 1,
      name: 'Erwin Brown',
      position: 'UI Designer',
      profile: 'assets/images/users/user-2.jpg'
    },
    {
      id: 2,
      name: 'Jacob Deo',
      position: 'Developer',
      profile: 'assets/images/users/user-5.jpg'
      */
    }]

  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.eventService.broadcast(EventType.SHOW_RIGHT_SIDEBAR, true);
  }

  /**
* Toggle the menu bar when having mobile screen
*/
  toggleMobileMenu(event: any) {

    this.topnavCollapsed = !this.topnavCollapsed;
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  changeLanguage(lang: string): void {
    // Cambiar la URL completa según el idioma seleccionado
    const basePath = window.location.protocol + '//' + window.location.host;
    const newPath = lang === 'en' ? basePath + '/en' : basePath + '/es';
    window.location.href = newPath;
  }

  // Método para redirigir a "Mi Perfil" y recargar la página
  goToProfile(): void {
    if (this.urlProfile) {
      // Redirigir a la URL cargándola en el navegador
      window.location.href = this.urlProfile;
    }
  }


}
